// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { scan } from 'react-scan';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/app-base.css';
import './styles/app-components.css';
import './styles/app-utilities.css';
import './styles/overriding-styles.css';
import 'react-image-crop/dist/ReactCrop.css';
import App from './App';
import ErrorBoundary from './app/shared-components/ErrorBoundary/ErrorBoundary';
import { HelmetProvider, Helmet } from 'react-helmet-async';

// scan({
//   enabled: true,
// });

const helmetContext = {};

// Create a root element
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// Render the app without StrictMode for better HMR compatibility
root.render(
  <ErrorBoundary>
    <HelmetProvider context={helmetContext}>
      <Helmet>
        <title>MyUtilities</title>
      </Helmet>
      <App />
    </HelmetProvider>
  </ErrorBoundary>,
);

// Add HMR acceptance
if (import.meta.hot) {
  import.meta.hot.accept();
}
